import { ARRAY_OF_NOTIFICATIONS_01 } from '../../../mocks/notifications.data';
import { delay, map, startWith } from 'rxjs/operators';
import { injectable } from 'inversify';
import { INotificationsAdapter } from './notifications-adapter.interface';
import { NEVER, Observable } from 'rxjs';
import { NotificationMessagesListTransaction } from '../../../interfaces';

const MAX_RESPONSE_DELAY = 2_000;

@injectable()
export class NotificationsAdapterServiceMock implements INotificationsAdapter {

    notificationsObservable(): Observable<NotificationMessagesListTransaction> {
        return NEVER.pipe(
            startWith(ARRAY_OF_NOTIFICATIONS_01),
            delay(MAX_RESPONSE_DELAY * Math.random()),
            map((notifications) => {
                return {
                    snapshot: notifications,
                };
            }),
        );
    }
}
